export const BROWSER_AUTOCOMPLETE = {
  disabled: "off",
  enabled: "on",
  loginUsername: "username",
  currentPassword: "current-password",
  newPassword: "new-password",
  oneTimeCode: "one-time-code",
} as const;
